// extracted by mini-css-extract-plugin
export default {"label":"YhnsIRIf6VFlkqhtyJ1A","error":"X6UOdVntAkHIAoHcdQoS"};